module.exports = __webpack_public_path__ + "static/media/ro.6a9bc557.png";